import React, { useContext } from "react";
import HeaderNav from "../navigation/HeaderNav";
import WishlistModal from "../modal/WishlistModal";
import CartModal from "../modal/CartModal";
import HeaderCategoryArea from "./HeaderCategoryArea";
import { FarzaaContext } from "../../context/FarzaaContext";
import { Link } from "react-router-dom";

const HeaderSection4 = () => {
  const {
    handleWishlistShow,
    handleCartShow,
    isHeaderFixed,
    cartCakeAmount,
    handleRemoveCake,
    handleCakeQuantityChange,
    cartCakes,
    wishlistCakes,
    handleRemoveCakeWishlist,
    handleSidebarOpen,
  } = useContext(FarzaaContext);

  return (
    <header
      className={`fz-3-header-section to-be-fixed ${isHeaderFixed ? "fixed" : ""
        }`}
    >
      <div className="row m-0 align-items-center">
        <div className="col-lg-5 col-md-6 col-9">
          <div className="fz-3-header-left-content d-flex align-items-center">
            <div className="fz-3-header-section">
              <Link to="/">
                <img
                  src="assets/images/your-fusion-chef-logo-notagline.png"
                  alt="logo"
                  className="fz-3-logo"
                />
                <a className="fz-header-title">
                  Private Fusion Chef
                </a>

              </Link>
            </div>
          </div>
        </div>

        <div className="col-2 col-xs-12 header-nav-container order-3 order-lg-2">
          <HeaderNav position={"justify-content-center"} />
        </div>

        <div className="col-lg-3 col-md-6 col-2 order-2 order-lg-3">
          <div className="fz-header-right-content">
            <ul className="fz-header-right-actions d-flex align-items-center justify-content-end">
             
              <li>
                <a
                  role="button"
                  onClick={handleSidebarOpen}
                  className="fz-hamburger d-block d-lg-none"
                >
                  <i className="fa-light fa-bars-sort"></i>
                </a>
              </li>
            </ul>
            
          </div>
        </div>
      </div>
    
    </header>
  );
};

export default HeaderSection4;
